import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllTravels() {
  return (
    <ModulePlaceholderList
      title="Travel requests"
      newPath="/panel/travels/new"
      newLabel="New travel request"
    />
  );
}
